export default {
    maskMobile(mobile) {
        if (typeof mobile === 'string' && mobile.length === 11) {
            return `${mobile.substr(0, 3)}****${mobile.substr(7)}`;
        }
        return mobile;
    },
    splitFirst(str, sep = ',') {
        if (typeof str === 'string') {
            const trimStr = str.trim();
            if (trimStr.length > 0) {
                return trimStr.split(sep)[0];
            }
        }
        return `${str}`;
    },
    /**
     * 将数组中的项用指定的符号（默认，）连成字符串
     * @param arr 待连接的数组
     * @param sep 分隔符
     * @returns {*} 连接后的字符串
     */
    arrayJoin(arr, sep = '，') {
        if (Array.isArray(arr)) {
            return arr.join(sep);
        }
        return arr;
    },
};
